export default __webpack_public_path__ + "static/media/huewon_crop_resize.ef166260.jpg";